import { Input } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React from 'react';

const TimeInput = (props) => (
  <article className={`${props.className} ${props.errorMessage !== '' ? 'error' : ''} u-rounded`}>
    <Input
      className="ncss-input pt2-sm pl4-sm pb2-sm pr2-sm"
      errorMessage={props.errorMessage}
      id={props.id}
      isDisabled={props.isDisabled}
      label={props.label}
      type="time"
      value={props.value}
      onChange={({ target: { value } }) => props.onChange(value)}
    />
  </article>
);

TimeInput.defaultProps = {
  className: '',
  errorMessage: '',
  id: '',
  isDisabled: false,
};

TimeInput.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default TimeInput;
